/* global $ */
import React, { useState, useRef } from 'react';
import * as XLSX from "xlsx";
import axios from 'axios';
import Swal from 'sweetalert2';

function Bulkupload() {
    const [data, setData] = useState([]);
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);  // Create a ref for the file input


    const handleClearFile = () => {
        setFile(null);  // Optionally clear the file state as well
        if (fileInputRef.current) {
            fileInputRef.current.value = '';  // Clear the file input field manually
        }
    };

    // Handle file selection
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleDownloadSampleFile = async () => {
        try {
            const response = await axios.get('https://api.sivammoto.in/api/billing/download-sample', {
                responseType: 'blob', // Ensure the response is treated as a binary file
            });

            // Create a temporary URL for the file
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);

            // Create a link element and programmatically click it
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'sivam_moto_bulk_upload.xlsx'); // Set the file name
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading the sample file:', error);
        }
    };

    // Handle bulk upload submission
    const handleBulkSubmit = async (e) => {
        e.preventDefault();

        if (!file) {
            Swal.fire("Error!", "Please select a file to upload.", "error");
            return;
        }

        try {
            // Create a FileReader to read the file
            const reader = new FileReader();

            reader.onload = async (event) => {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                let jsonData = XLSX.utils.sheet_to_json(worksheet);

                // Convert Excel dates (numbers) to valid date strings
                jsonData = jsonData.map((record) => {
                    const convertExcelDate = (excelDate) => {
                        if (typeof excelDate === "number") {
                            const date = new Date((excelDate - 25569) * 86400 * 1000); // Convert Excel date to JS date
                            return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
                        }
                        return excelDate; // Return as-is if it's already a string
                    };

                    return {
                        ...record,
                        date: convertExcelDate(record.date),
                    };
                });

                console.log("Processed JSON Data:", jsonData); // Debugging log

                try {
                    const user_id = localStorage.getItem('user_id')
                    // Send JSON data to the backend API
                    const response = await axios.post(`https://api.sivammoto.in/api/billing/bulk-upload/${user_id}`, jsonData, {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    });

                    console.log("API Response:", response.data); // Log the response

                    // Update UI with the data received from the API
                    if (response.data && response.data.added_bills) {
                        setData((prevData) => [...prevData, ...response.data.added_bills]);
                    }

                    // Reset file input and show success message
                    setFile(null);
                    Swal.fire("Uploaded!", response.data.message, "success");
                    $('#bulkUploadModal').modal('hide');
                } catch (error) {
                    console.error("Error uploading bulk data:", error);
                    const errorMessage = error.response?.data?.message || error.response?.statusText || 'An unknown error occurred';
                    const errors = error.response?.data?.errors;
                    const errorDetails = errors ? errors.join('\n') : errorMessage;
                    Swal.fire('Error!', `There was an issue uploading the data: ${errorDetails}`, 'error');
                    $('#bulkUploadModal').modal('hide');
                    handleClearFile();
                }

            };

            reader.readAsArrayBuffer(file);
        } catch (error) {
            console.error("Error processing the file:", error);
            Swal.fire("Error!", "There was an issue processing the file. Please try again.", "error");
        }
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                        <h1 className="m-0">Bulk Upload</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Bulk Upload</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section class="content">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-md-12">
                            <div class="card card-maroon">
                                <div class="card-header">
                                    <h3 class="card-title">Bulk Upload</h3>
                                </div>
                                <form onSubmit={handleBulkSubmit}>
                                    <div className="row">
                                        <div className="col-sm-2"></div>
                                        <div className="col-sm-8">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputFile">File input</label>
                                                <div className="input-group">
                                                    <div className="custom-file">
                                                        <input type="file" className="custom-file-input" id="bulkFileInput" accept=".xlsx, .xls" onChange={handleFileChange} ref={fileInputRef} />
                                                        <label className="custom-file-label" htmlFor="bulkFileInput">{file ? file.name : "Choose file"}</label>
                                                    </div>
                                                    <div className="input-group-append">
                                                        <button type="submit" className="btn btn-primary">Upload</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-2"></div>
                                        <button type="button" className="btn btn-primary" onClick={handleDownloadSampleFile}>Download Sample File</button>
                                    </div>
                                    <div className="row"></div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Bulkupload